import type { BoardDefinition } from '@skyrover/shared/types';

/** Real board photos for standard boards. Skyrover keeps a custom SVG. */
const BOARD_IMAGES: Record<string, string> = {
  'arduino-uno': '/boards/arduino-uno.jpg',
  'arduino-nano': '/boards/arduino-nano.jpg',
  'arduino-mega-2560': '/boards/arduino-mega-2560.jpg',
  'esp8266-nodemcu': '/boards/esp8266-nodemcu.jpg',
  'esp32-devkit': '/boards/esp32-devkit.jpg',
  'skyrover-esp32-s3': '/boards/skyrover-esp32-s3.svg',
};

export function getBoardImageUrl(board: BoardDefinition): string {
  return board.metadata?.imageUrl ?? BOARD_IMAGES[board.id] ?? '/boards/default.svg';
}
